import axios from "axios";
import Cookies from "universal-cookie";
export const cookies = new Cookies();
const user = cookies.get("user");

// Base URL for uploaded media (images) served from the backend's /uploads
// folder. Kept separate from the API baseURL below since production fronts
// it through a reverse proxy at /api (no /v1), while locally the backend
// serves it straight off the server root.
export const MEDIA_BASE_URL = "https://captureedits.com/api";
// export const MEDIA_BASE_URL = "http://localhost:4000";

const API = axios.create({
  baseURL: "https://captureedits.com/api/v1",
  // baseURL: "http://localhost:4000/v1",
  headers: { Authorization: `Bearer ${user?.tokens?.access?.token}` },
});
export default API;
